module.exports = __webpack_public_path__ + "img/douyin-account.dd6fe715.png";